var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0223 5.4697L0.715843 21.7761L0.0119676 28.463C-0.105345 29.3428 0.657187 30.1053 1.53703 29.988L8.22385 29.2842L24.5303 12.9777L17.0223 5.4697ZM29.1641 4.35523L25.6448 0.835852C24.589 -0.278617 22.7706 -0.278617 21.6561 0.835852L18.3714 4.1206L25.8794 11.6286L29.1641 8.34386C30.2786 7.22939 30.2786 5.41104 29.1641 4.35523Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3d55e3f4f71499c526b760eb5e3f938a.svg";
export { ForwardRef as ReactComponent };